<template>
    <div class="Login">
        <div class="LoginContainer">
            <div class="LoginError" :class="{ 'LoginError--visible': hasError }">
                {{ error }}
            </div>
            <form class="LoginForm" @submit.prevent="onSubmit" :disabled="true">
                <h1 class="LoginForm-title">Control admin panel</h1>
                <label>
                    <p>Email</p>
                    <input @input="onChange" required v-model="form.email" />
                </label>

                <label>
                    <p>Password</p>
                    <input @input="onChange" required type="password" v-model="form.password" />
                </label>
                <button :disabled="!submitEnabled">Log in to control</button>
            </form>
        </div>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import axios from 'axios';
import get from 'lodash/get';

export default {
    name: 'LoginPage',
    data: function () {
        return {
            form: {
                email: '',
                password: ''
            },
            submitEnabled: false,
            error: '',
            hasError: false
        };
    },

    methods: {
        onChange() {
            this.submitEnabled = !isEmpty(this.form.email, this.form.password);
            this.hasError = false;
        },

        onSubmit() {
            axios.post('/control/api/auth/', { email: this.form.email, password: this.form.password })
                .then(() => location.reload())
                .catch((error) => {
                    this.error = get(error, 'response.data.error') || 'Unknown error, please try later.';
                    this.hasError = true;
                });
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .Login;

@{r} {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: @Graphik-LCG;
    background-color: #1a1a1a;

    &Form {
        margin-top: -40px;
        min-width: 550px;
        padding: 60px;
        background-color: white;
        border-radius: 16px;
        box-shadow: 20px 20px 50px 10px rgba(255, 255, 255, 0.8);

        h1 {
            margin-top: 0;
        }

        label {
            > p {
                margin: 0 0 5px 0;
                font-size: 12px;
            }
        }

        input {
            background: transparent;
            font-size: 14px;
            line-height: 14px;
            color: @color-black;
            border: 1px solid rgba(102, 94, 94, 0.357);
            text-align: left;
            display: block;
            width: 100%;
            height: 40px;
            outline: none;
            padding: 0 20px;
            margin: 0 0 20px 0;
            border-radius: 16px;

            &:focus {
                outline-offset: 0 !important;

                &::placeholder {
                    color: transparent;
                }

                &:-ms-input-placeholder {
                    color: transparent;
                }

                &::-ms-input-placeholder {
                    color: transparent;
                }
            }
        }

        input::-webkit-credentials-auto-fill-button {
            background-color: white;
            margin: 0;
        }

        >button {
            width: 100%;
            height: 40px;
            background-color: black;
            color: white;
            font-size: 12px;
            line-height: 14px;
            margin-top: 20px;
            cursor: pointer;
            border-radius: 16px;
            border: 1px solid black;
            transition: background-color .3s ease, color .3s ease;

            &:hover {
                color: black;
                background-color: white;
            }
        }
    }

    &Error {
        align-items: center;
        align-self: center;
        color: white;
        text-align: center;
        font-size: 16px;
        opacity: 0;
        transition: opacity 0.3s, transform 0.3s;
        transform: translateY(0);
        pointer-events: none;
        height: 50px;
        margin-top: 20px;

        &--visible {
            transform: translateY(-40px);
            opacity: 1;
            pointer-events: all;
        }
    }
}

body {
    min-height: 100vh;
    position: relative;
    background-color: @color-black;

    &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -2;
        margin-top: -182px;
        background-size: cover;
        background-repeat: none;
        background-position: center bottom;
    }

    &:after {
        content: "";
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 176px;
        height: 240px;
        z-index: -1;
    }
}
</style>
